import {ethers} from "ethers";
import cloneDeep from 'lodash/cloneDeep';
import { Provider } from "@ethersproject/abstract-provider";

import { abi as ERC20_ABI } from '../../contract_abis/erc20_rw';
import { abi as BTX_ABI } from '../../contract_abis/btx_abi';

import { fetchNFTsMetadataBackend } from "../backendHelpers";

import { TokenDataBase, TokenDataType } from "./commonInterfacesAndEnums";
import { GLIP_BACKEND_TOKEN_INFO_STORAGE_KEY } from "../../constants/storage_constats";
import { createProvider, jsonRpcUrlMap, networkToChainId } from "../../constants/EIP1193";
import {addInformationToNFTTokenList} from "./nftBalanceServices/nftBalanceService";

const CoinGecko = require('coingecko-api');

const CoinGeckoClient = new CoinGecko();


export const BTX_INR_RATE = .00083;

function preProcessBackendRespondForTokens(
    currencies:any, tokenDatas:any,
    contracts:any, convertInfoMap:any){
    const tokenIdToContractMap: any = {};
    const contractIdToContractMap: any = {};
    const tokenIdToConvertInfoMap: any = {};
    const tokenIdToTokenMap: any = {};
    
    for (const contract of contracts) {
        // assert that contract.id is exists and is not null
        contractIdToContractMap[contract.id] = contract;
    }
    for (const token of tokenDatas) {
        tokenIdToContractMap[token.id] = contractIdToContractMap[
            token.assetContractId];
        tokenIdToTokenMap[token.id] = token;
    }
    for (const currency of currencies) {
        tokenIdToConvertInfoMap[currency.tokenMetadataId] = (
            convertInfoMap[currency.id]);
    }
    return {
        tokenIdToContractMap,
        contractIdToContractMap,
        tokenIdToConvertInfoMap,
        tokenIdToTokenMap        
    }    
}

async function getConversionRates() {
    try {
        // fetch the price of 1 INR in terms of USD and BLR
        const data = await CoinGeckoClient.simple.price({
            ids: ['usd',],
            vs_currencies: ['inr'],
        });
        
        if (data.success) {
            let usd_rate = data.data.usd.inr;
            return {usd_rate:usd_rate}
        }
    } catch(error) {
        console.log('tokenConvertInfo', error);
    }
}

async function addBalanceInformationToToken(
    token:any,
    tokenIdToContractMap:any,
    tokenIdToConvertInfoMap:any,
    walletAddress:any
){
    const contract = tokenIdToContractMap[token.id];
    let tokenConvertInfo:any = tokenIdToConvertInfoMap[token.id];
    // if(token.id==="63abeca4750adb1db4122fea"){
    //     let conversionRate:any = await getConversionRates()
    //     if(conversionRate){
    //         let usdRate = parseFloat(((BTX_INR_RATE) / conversionRate['usd_rate']).toFixed(6));
    //         console.log('usdRate', usdRate);
    //         tokenConvertInfo = {}
    //         tokenConvertInfo["exchange"] = [
    //             {currency: "USD", rate: usdRate},
    //             {currency: "INR", rate: BTX_INR_RATE},
    //             {currency: "BLR", rate: 0},
    //         ];
    //     }
    // }
    if(token.id==="673df8c30ac0ff7c5f7319c0"){
        let conversionRate:any = await getConversionRates()
        if(conversionRate){
            let usdRate = parseFloat(((BTX_INR_RATE) / conversionRate['usd_rate']).toFixed(6));
            console.log('usdRate', usdRate);
            tokenConvertInfo = {}
            tokenConvertInfo["exchange"] = [
                {currency: "USD", rate: usdRate},
                {currency: "INR", rate: BTX_INR_RATE},
                {currency: "BLR", rate: 0},
            ];
        }
    }
    //@ts-ignore
    let providerUrl: string = jsonRpcUrlMap[networkToChainId.get(contract.chain)] ? jsonRpcUrlMap[networkToChainId.get(contract.chain)][0] : null;
    if(!providerUrl){
        return;
    }
    const {prov} = createProvider(contract.chain);
    const balance: any = await getTokenBalance(
            prov, token, contract, walletAddress);
    addExchangeInformation(
        tokenConvertInfo, balance, token);
    token.balance = balance;
    let data:any = {
        ...token,
        currency:tokenConvertInfo,
        assetContractId: contract.id,
        contractAddress: contract.contractAddress,
        quantity: balance.balance,
        exchangeRateInfos: tokenConvertInfo ? tokenConvertInfo.exchange : [],
    };
    
    let updatedToken:any = {
            ...data,
            ...tokenIdToContractMap[data.id]
        }
    // Send this token through an event using window
    if(updatedToken.contractAddress === '0xF0075b06b4229C20B7c22b7E63D90723b3551861'
        || updatedToken.contractAddress === '0x777BaEb8bDaD0E95ea94E3a4Bcc6cC2938763725'
    ){
        let tokenName =  updatedToken.name;
        let symbol =  updatedToken.symbol;
        let updatedToken2 = cloneDeep(updatedToken);
        updatedToken2.id = updatedToken2.id + '1';
        updatedToken2.quantity = balance.cashBalance;
        updatedToken2.name = tokenName + " (Unlocked)";
        updatedToken2.symbol = symbol + " (Unlocked)";
        
        window.dispatchEvent(new CustomEvent(
            'tokenAdded', {detail: {
                'token': updatedToken2}}));
        updatedToken.name = tokenName + " (Lock)";
        updatedToken.symbol = symbol + " (Lock)";
        updatedToken.quantity = balance.rewardBalance;
        updatedToken.currency = undefined;
        updatedToken.exchange = undefined;
        window.dispatchEvent(new CustomEvent(
            'tokenAdded', {detail: {
                'token': updatedToken}}));
        return [updatedToken, updatedToken2];
    }
    
    window.dispatchEvent(new CustomEvent(
        'tokenAdded', {detail: {
            'token': updatedToken}}));
    return [updatedToken];
}

    
async function addInformationToNonNFTTokenList(
    backendResponse:any, walletAddress: string,) {
    let tokenMetadatas = backendResponse.coins.tokenMetadatas
    let {tokenIdToContractMap,
         tokenIdToConvertInfoMap,} = preProcessBackendRespondForTokens(
             (backendResponse.coins.currencies || []),
             (backendResponse.coins.tokenMetadatas || []),
             (backendResponse.coins.contracts || []),
             (backendResponse.coins.currencyMap || {})
         );
    tokenMetadatas.sort((a: any, b: any) => {
        if (a.id === "63abeca4750adb1db4122fea") return -1;
        if (b.id === "63abeca4750adb1db4122fea") return 1;
        return 0;
    });
    // Map over tokenMetadatas and create an array of promises
    // remove tokens if provider is not available
    tokenMetadatas = tokenMetadatas.filter((tokenMetadata:any) => {
        const contract = tokenIdToContractMap[tokenMetadata.id];
        //@ts-ignore
        let providerUrl: string = jsonRpcUrlMap[networkToChainId.get(contract.chain)] ? jsonRpcUrlMap[networkToChainId.get(contract.chain)][0] : null;
        if(!providerUrl){
            return false;
        }
        return true;
    });
    let promises = tokenMetadatas.map((tokenMetadata:any) =>
        addBalanceInformationToToken(
            tokenMetadata, tokenIdToContractMap,
            tokenIdToConvertInfoMap, walletAddress
        )
    );

    // Wait for all promises to resolve
    let tokenList = await Promise.all(promises);

    // Flatten the array if necessary
    tokenList = [].concat(...tokenList);

    window.dispatchEvent(new CustomEvent('allTokenAdded', {
        detail: {'tokenList': tokenList}
    }));
}


async function getTokenBalance(
    provider: Provider, token: TokenDataBase,
    contract: any, address: string,){
  let balance;
    if (token.type === TokenDataType.ERC20) {
        if(contract.contractAddress === "0xF0075b06b4229C20B7c22b7E63D90723b3551861"){
            balance = await getBtxBalance(
                provider, contract.contractAddress,
                contract.chain, address, token.decimals);
        }
        else if(contract.contractAddress === "0x777BaEb8bDaD0E95ea94E3a4Bcc6cC2938763725"){
            balance = await getBtxBalance(
                provider, contract.contractAddress,
                contract.chain, address, token.decimals);
        }
        else{
            balance = await getERC20Balance(
                provider, contract.contractAddress,
                contract.chain, address, token.decimals);
        }
    } else if (token.type === TokenDataType.ETH) {
        balance = await fetchNativeBalance(
            provider,  address, token.decimals);
    } else {
        return null;
    }
    return balance;
}


function addExchangeInformation(
    tokenConversionInfo:any, balance:any, token:any){
    if(!tokenConversionInfo){
        return;
    }
    for (let index = 0; index < (tokenConversionInfo.exchange.length); index++) {
        // exchange means fiat exchange rate here.
        const exc = tokenConversionInfo.exchange[index];
        let val;
        if(balance.cashBalance){
            val = (balance.cashBalance * (exc.rate ? exc.rate : 0));
            tokenConversionInfo.exchange[index].value = val;
        }
        else{
            val = parseFloat(
                ethers.utils.formatUnits(
                    balance.rawBalance.toString(),
                    token.decimals).toString()) * (exc.rate ? exc.rate : 0);
            tokenConversionInfo.exchange[index].value = val;
        }
        
    }
    token.exchange = tokenConversionInfo.exchange;
}

async function getERC20Balance(
    provider: Provider, contractAddress: string,
    chain: any, walletAddress: string,
    decimals: number = 18){
    const raContract = new ethers.Contract(
        contractAddress, ERC20_ABI, provider);
    const balance = await raContract.balanceOf(walletAddress);
    return {
        chain: chain,
        balance: ethers.utils.formatUnits(balance, decimals),
        decimals: decimals,
        rawBalance: balance.toString(),
    };
}

async function getBtxBalance(
    provider: Provider, contractAddress: string,
    chain: any, walletAddress: string,
    decimals: number = 18){
    const raContract = new ethers.Contract(
        contractAddress, BTX_ABI, provider);
    const rewardBalance = await raContract.rewardBalanceOf(walletAddress);
    const cashBalance = await raContract.transferrableBalanceOf(walletAddress);
    return {
        chain: chain,
        //balance: ethers.utils.formatUnits(balance, decimals),
        decimals: decimals,
        rewardBalance: ethers.utils.formatUnits(
            rewardBalance, decimals),
        cashBalance: ethers.utils.formatUnits(
            cashBalance, decimals),
    };
}

async function fetchNativeBalance(
    provider: Provider, walletAddress: string,
    decimals: number = 18){
    const balance = await provider.getBalance(walletAddress);
    return {
        balance: ethers.utils.formatUnits(balance, decimals),
        decimals: decimals,
        symbol: TokenDataType.ETH,
        rawBalance: balance,
    };    
}

export async function fetchAndProcessTokens(){
    let glipggToken:any = localStorage.getItem(GLIP_BACKEND_TOKEN_INFO_STORAGE_KEY);
    if(!glipggToken){return;}
    glipggToken = JSON.parse(glipggToken);
    if(!glipggToken.id){return;}
    let walletAddress:any = glipggToken.id;
    const backendResponse = await fetchNFTsMetadataBackend(
        walletAddress);
    if(!backendResponse){return null;}
    let nonNFTTokenList = addInformationToNonNFTTokenList(
        backendResponse, walletAddress);
    let nftTokenList = await addInformationToNFTTokenList(
        backendResponse, walletAddress);
    return {tokens:nonNFTTokenList, nfts: nftTokenList};
}
